var map = {
	"./e-comm.png": 107,
	"./glosso.png": 890,
	"./mock.png": 740,
	"./projectTorcreads.png": 517,
	"./shehired.png": 198,
	"./songphile.png": 321,
	"./sprite.png": 594,
	"./torc.svg": 423
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 303;